<template>
  <div>
    <div class="columns is-multiline is-mobile">
      <div class="column">
        <window title="Contact us #1">
          <div class="contact-us-box">
            <div class="columns is-multiline is-mobile">
              <div class="column is-full">
                <GmapMap style="height: 200px;" :options="{gestureHandling: 'cooperative'}"
                  :zoom="15" :center="{lat: 44.441399, lng: 26.099821}"
                >
                  <GmapMarker label="★" :position="{
                      lat: 44.441399,
                      lng: 26.099821,
                    }"
                  />
                </GmapMap>
              </div>
              <div class="column is-full">
                <h3 class="title is-5 p-b-xs">Contact us</h3>
                <p class="subtitle is-6">Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Odit quisquam esse animi hic, reprehenderit voluptas. Cumque temporibus illum
                  sunt, obcaecati laborum deleniti aspernatur rem sit voluptas perferendis itaque
                  dignissimos iste? Lorem, ipsum dolor sit amet consectetur adipisicing elit. Unde
                  magni mollitia harum accusantium provident fuga, dignissimos minima? Porro tempora
                  consequatur natus sapiente nobis harum corporis sunt voluptas! Architecto,
                  impedit! Pariatur!
                </p>
              </div>
              <div class="column is-full-mobile">
                <div class="field">
                  <label class="label">Name</label>
                  <div class="control">
                    <input class="input" type="text" placeholder="Your name">
                  </div>
                </div>
                <div class="field">
                  <label class="label">Email address</label>
                  <div class="control">
                    <input class="input" type="text" placeholder="Your email address">
                  </div>
                </div>
                <div class="field is-hidden-desktop">
                  <label class="label">Message</label>
                  <div class="control">
                    <textarea class="textarea" rows="2" placeholder="Textarea"></textarea>
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field is-hidden-touch">
                  <label class="label">Message</label>
                  <div class="control">
                    <textarea class="textarea" rows="2" placeholder="Textarea"></textarea>
                  </div>
                </div>
                <div class="field is-grouped flex-end">
                  <div class="control">
                    <button class="button is-link">Submit</button>
                  </div>
                  <div class="control">
                    <button class="button is-text">Cancel</button>
                  </div>
                </div>
              </div>
              <div class="column field is-full-mobile company-info">
                <p class="title is-4">
                  <strong>{{ company }}</strong>
                </p>
                <p>
                  <span>
                    <i class="fas fa-map-marker"> </i>
                  </span> {{ addressLine1 }}</p>
                <p>{{ addressLine2 }}</p>
                <p>For support or any questions:</p>
                <p>Email us at
                  <a href="">
                    <span>
                      <i class="fas fa-envelope"> </i>
                    </span> {{ email }}</a>
                </p>
                <p>Call us at
                  <a href="">
                    <span>
                      <i class="fas fa-phone"> </i>
                    </span> {{ phone }}</a>
                </p>
              </div>
            </div>
          </div>
        </window>
      </div>
    </div>
  </div>
</template>


<script>
import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDH2YAu-XzZ52eE26ZW5zG0TIgmyTJYDqs',
    libraries: 'places',
  },
});


export default {
  data() {
    return {
      google: VueGoogleMaps.gmapApi,
      phone: '123-456-789',
      company: 'Awesome Company, Inc',
      addressLine1: 'Magic Street, 3/4',
      addressLine2: 'San Francisco, CA 65467',
      email: 'email@email.com',
    };
  },
};
</script>

<style scoped>
.contact-us-box {
  padding: 2rem;
}
@media screen and (max-width: 768px) {
  .contact-us-box {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
.company-info  {
  font-size: 1rem !important;
}
</style>
